import { Filter } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import { DatePickerWithPresets } from "@/shared/components/range-picker/RangePicker";
import { DynamicSelectFilter } from "@/shared/components/filters/Filters";
import type { SystemDictionary } from "@/shared/api/filters";
import { useState, type Dispatch, type SetStateAction } from "react";
import type { UsersFiltersState } from "../../pages/UsersPage";
import { Input } from "@/shared/components/ui/input";



interface UsersFilterProps {
  dictionary: SystemDictionary | undefined;
  setFilters: Dispatch<SetStateAction<UsersFiltersState>>;
  filters: UsersFiltersState;
}
export function UsersFilter({
  dictionary,
  setFilters,
  filters,
}: UsersFilterProps) {
  // Функция для обновления конкретного фильтра
  const updateFilter = (key: string, value: string) => {
    setFilters((prev) => ({ ...prev, [key]: value === "all" ? "" : value }));
  };

  const resetFilters = () => {
    setFilters({ role: "", status: "", keyword: "" });
  };

  if (!dictionary) return null;
  console.log("dictionary", dictionary);

  return (
    <div className="bg-white rounded-t-lg border p-4">
      <div className="flex flex-wrap items-center gap-3">
        <Filter className="w-5 h-5 text-gray-500" />
        {/* 2. Пример с объектами {code, label} (employee_roles) */}
        <Input
          placeholder="Поиск по имени, фамилии или email"
          value={filters.keyword}
          onChange={(e) => updateFilter("keyword", e.target.value)}
          className="h-10 w-[280px]"
        />

        {/* Роль */}
        <DynamicSelectFilter
          placeholder="Роль сотрудника"
          data={dictionary.employee_roles}
          value={filters.role || undefined}
          onChange={(val) => updateFilter("role", val)}
          valueExtractor={(item) => item.code}
          labelExtractor={(item) => item.label}
        />

        {/* Статус */}
        <DynamicSelectFilter
          placeholder="Статус"
          data={dictionary.employee_statuses}
          value={filters.status || undefined}
          onChange={(val) => updateFilter("status", val)}
          valueExtractor={(item) => item.code}
          labelExtractor={(item) => item.label}
        />

        <Button
          variant="ghost"
          size="sm"
          className="h-10"
          onClick={resetFilters}
        >
          Сброс фильтров
        </Button>
      </div>
    </div>
  );
}
